






























































import { defineComponent } from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';

interface Step {
  title: string;
  icon: string;
}

export default defineComponent({
  name: 'OrderStatus',
  components: {
    SvgImage,
    JetUiButton,
  },
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    orderId: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      steps: [
        { title: 'Pendente', icon: 'pending_payment' },
        { title: 'Aprovado', icon: 'approved_payment' },
        { title: 'Em separação', icon: 'preparing_order' },
        { title: 'Enviado', icon: 'fast_delivery' },
        { title: 'Fechado', icon: 'cancel_cross' },
        { title: 'Cancelado', icon: 'cancel_cross' },
      ] as Step[],
    };
  },
  computed: {
    filteredSteps(): Step[] | string {
      if (this.steps[this.currentStep]?.title === 'Cancelado' || this.steps[this.currentStep]?.title === 'Fechado') {
        return 'Cancelado';
      }

      return this.steps.filter((step) => step.title !== 'Fechado' && step.title !== 'Cancelado');
    },
  },

});
